import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";

// Async thunk to fetch products from backend
export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async () => {
    const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/product`);
    const data = await res.json();
    return data;
  }
);

export const fetchCategories = createAsyncThunk(
  "product/fetchCategories",
  async () => {
    const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/categories`);
    const data = await res.json();
    return data;
  }
);

const initialState = {
  productList: [],
  categoryList: [], // dynamic categories
  cartItem: [],
  status: "idle", // idle | loading | succeeded | failed
  categoryStatus: "idle",
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setDataProduct: (state, action) => {
      state.productList = [...action.payload];
    },
    addCartItem: (state, action) => {
     // const check = state.cartItem.some(el => el._id == action.payload._id);

      // if (check) {
      //   toast('Bakery goods already in cart!');
      // } else {
        toast("Added to cart!");
        const total = Number(action.payload.price);
        state.cartItem = [...state.cartItem, { ...action.payload, qty: 1, total: total }];
      // }
    },
    deleteCartItem: (state, action) => {
      const index = state.cartItem.findIndex(el => el._id === action.payload);
      if (index !== -1) {
        state.cartItem.splice(index, 1);
        toast('Deleted!');
      }
    },
    increaseQty: (state, action) => {
      const index = state.cartItem.findIndex(el => el._id === action.payload);
      if (index !== -1) {
        let qty = state.cartItem[index].qty;
        qty++;
        state.cartItem[index].qty = qty;

        const price = Number(state.cartItem[index].price);
        state.cartItem[index].total = price * qty;
      }
    },
    decreaseQty: (state, action) => {
      const index = state.cartItem.findIndex(el => el._id === action.payload);
      if (index !== -1 && state.cartItem[index].qty > 1) {
        let qty = state.cartItem[index].qty;
        qty--;
        state.cartItem[index].qty = qty;

        const price = Number(state.cartItem[index].price);
        state.cartItem[index].total = price * qty;
      }
    },
    clearCart: (state) => {
      state.cartItem = [];
      toast.success("Cart cleared after order!");
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.productList = action.payload;
      })
      .addCase(fetchProducts.rejected, (state) => {
        state.status = "failed";
        toast.error("Failed to fetch products!");
      })
      .addCase(fetchCategories.pending, (state) => {
        state.categoryStatus = "loading";
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categoryStatus = "succeeded";
        state.categoryList = action.payload;
      })
      .addCase(fetchCategories.rejected, (state) => {
        state.categoryStatus = "failed";
        toast.error("Failed to fetch categories!");
      });
  }
});

export const { setDataProduct, addCartItem, deleteCartItem, increaseQty, decreaseQty,clearCart } = productSlice.actions;
export default productSlice.reducer;
